"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const core_1 = require("@material-ui/core");
const lab_1 = require("@material-ui/lab");
const react_1 = tslib_1.__importStar(require("react"));
const react_redux_1 = require("react-redux");
const actions_1 = require("../../../actions/actions");
const api_1 = require("../../../../utils/api");
const themes_1 = require("../../../../utils/themes");
const react_spinners_1 = require("react-spinners");
const Utils_1 = require("../../../../utils/Utils");
const getSensor_1 = require("../../../../utils/getSensor");
const style_1 = tslib_1.__importDefault(require("../../../../utils/style"));
const sub_layout_1 = require("src/app/auto-ml/layouts/sub-layout");
const project_initiation_step1_1 = require("../subSteps/projectInitiation/project-initiation-step1");
const project_initiation_step2_1 = require("../subSteps/projectInitiation/project-initiation-step2");
const js_cookie_1 = tslib_1.__importDefault(require("js-cookie"));
const environment_1 = require("src/environments/environment");
const core_2 = require("@material-ui/core");
const Utils_2 = require("../../../../utils/Utils");
const permission_1 = require("src/app/permission");
function ProjectInitiation(props) {
    const dispatch = react_redux_1.useDispatch();
    const mainStep = react_redux_1.useSelector((state) => state.mainStep.no);
    const ProjectInitiationData = react_redux_1.useSelector((state) => state.ProjectInitiationData);
    const [data, setData] = react_1.useState(ProjectInitiationData.data);
    react_1.useEffect(() => {
        console.log('ProjectInitiation', ProjectInitiationData);
    }, [ProjectInitiationData]);
    react_1.useEffect(() => {
        localStorage.setItem('pageFlag', 1);
        setData(initialState);
    }, []);
    react_1.useEffect(() => {
        console.log("data updated: ", data.stackedCSV);
    }, [data.stackedCSV]);
    const [loading, setLoading] = react_1.useState(false);
    const [type, setType] = react_1.useState("csv");
    const [batchList, setBatchList] = react_1.useState([]);
    const [devicesList, setDevicesList] = react_1.useState([]);
    const [sensors, setSensors] = react_1.useState([]);
    const [isMagmaDataFetched, setIsMagmaDataFetched] = react_1.useState(true);
    const [isMultipleDataset, setIsMultipleDataset] = react_1.useState(false);
    const [selectedSensors, setSelectedSensors] = react_1.useState([]);
    const [selectedSensorValue, setSelectedSensorValue] = react_1.useState("");
    const [currentStep, setCurrentStep] = react_1.useState(0);
    const [subStepperData, setSubStepperData] = react_1.useState([
        { required: true, text: "Project Details", active: true },
        { required: true, text: "Data Upload", active: false }
    ]);
    const [showSensorNamingPopup, setShowSensorNamingPopup] = react_1.useState(false);
    const [sensorCodes, setSensorCodes] = react_1.useState([]);
    const [editedSensorCodes, setEditedSensorCodes] = react_1.useState([]);
    const [showConfirmation, setShowConfirmation] = react_1.useState(false);
    const [showSubmit, setShowSubmit] = react_1.useState(false);
    const [missingColumns, setMissingColumns] = react_1.useState([]);
    const [deviceDataSensorCodes, setDeviceDataSensorCodes] = react_1.useState([]);
    const [inputErrors, setInputErrors] = react_1.useState({});
    const [inputSensorCodes, setInputSensorCodes] = react_1.useState([]);
    const [isUrlConfirmed, setIsUrlConfirmed] = react_1.useState(false);
    const initialState = {
        projectName: "",
        projectNameError: "",
        projectVersion: "",
        projectVersionError: "",
        problemType: "",
        problemTypeError: "",
        csv: "",
        stackedCSV: {},
        csvError: "",
        csvFileName: "",
        baseURL: "",
        baseURLError: "",
        accessToken: "",
        accessTokenError: "",
        userId: "",
        userIdError: "",
        batch: "",
        batchError: "",
        device: "",
        deviceError: "",
        startDate: "",
        startDateError: "",
        sensor: "",
        sensorError: "",
        endDate: "",
        endDateError: "",
        sensorData: [],
    };
    const [snackbarOpen, setSnackbarOpen] = react_1.useState(false);
    const [snackbarMessage, setSnackbarMessage] = react_1.useState("");
    const [snackbarType, setSnackbarType] = react_1.useState("");
    const [snackbars, setSnackbars] = react_1.useState([]);
    const styleLocal = style_1.default();
    const ButtonType = Object.freeze({
        ALL: "All",
        FETCH_DATA: "FetchData",
        CONFORM_URL: "ConformURL"
    });
    react_1.useEffect(() => {
        console.log('devicesList', devicesList);
        console.log('Sensor codes:', inputSensorCodes);
        if (devicesList && devicesList.length > 0 && inputSensorCodes.length > 0) {
            const allSensorCodes = devicesList.flatMap(device => device.sensorCodes);
            const uniqueSensorCodes = [...new Set(allSensorCodes)];
            setSelectedSensorValue(uniqueSensorCodes);
            setSensors(getSensor_1.mapSensorCodesToNames(uniqueSensorCodes, inputSensorCodes));
        }
        ;
    }, [devicesList]);
    react_1.useEffect(() => {
        localStorage.setItem('pageFlag', 1);
        setData(initialState);
        dispatch({ type: actions_1.RESET_UNWHITELISTED_STATE });
    }, []);
    react_1.useEffect(() => {
        if (showSubmit) {
            dispatch(actions_1.changeMainStep(mainStep + 1));
            localStorage.setItem('pageFlag', 2);
        }
    }, [showSubmit]);
    const handleCloseSnackbar = () => {
        setSnackbarOpen(false);
    };
    const setCurrentStepByClick = (step) => {
        if (step >= 0 && step < subStepperData.length && step <= currentStep) {
            const updatedSubStepperData = subStepperData.map((item, index) => (Object.assign({}, item, { active: index <= step })));
            setSubStepperData(updatedSubStepperData);
            setCurrentStep(step);
        }
    };
    const handleSensorCodeError = (message) => {
        setShowConfirmation(false);
        setShowSensorNamingPopup(false);
        addSnackbar(message, "error");
    };
    const handleFileTypeError = () => {
        setSnackbarMessage("Only CSV file type is allowed.");
        setSnackbarType("error");
        setSnackbarOpen(true);
    };
    const validateFields = (buttonType) => {
        let isValid = true;
        let errors = {};
        if (!data.projectName && buttonType === ButtonType.ALL) {
            isValid = false;
            errors.projectNameError = "* Project name is required";
        }
        if (!data.projectVersion && buttonType === ButtonType.ALL) {
            isValid = false;
            errors.projectVersionError = "* Project version is required";
        }
        if (!data.problemType && buttonType === ButtonType.ALL) {
            isValid = false;
            errors.problemTypeError = "* Problem type is required";
        }
        if (type === "csv" && !data.csv && currentStep === 1) {
            isValid = false;
            errors.csvError = "* CSV file is required";
        }
        if (type === "magma" && currentStep === 1) {
            if (!data.baseURL) {
                isValid = false;
                errors.baseURLError = "* Base URL is required";
            }
            if (!data.accessToken) {
                isValid = false;
                errors.accessTokenError = "* Access token is required";
            }
            if (!data.userId) {
                isValid = false;
                errors.userIdError = "* User Id is required";
            }
            if (!data.batch && buttonType === ButtonType.FETCH_DATA) {
                isValid = false;
                errors.batchError = "* Batch is required";
            }
            if (!data.device && buttonType === ButtonType.FETCH_DATA) {
                isValid = false;
                errors.deviceError = "* Device is required";
            }
            if (buttonType === ButtonType.FETCH_DATA && ((data.problemType !== "rca_ms" && data.sensor === "") ||
                (data.problemType === "rca_ms" && selectedSensors.length === 0))) {
                isValid = false;
                errors.sensorError = "* Sensor is required";
            }
            if (!data.startDate && buttonType === ButtonType.FETCH_DATA) {
                isValid = false;
                errors.startDateError = "* Start date is required";
            }
            if (!data.endDate && buttonType === ButtonType.FETCH_DATA) {
                isValid = false;
                errors.endDateError = "* End date is required";
            }
            if (buttonType === ButtonType.FETCH_DATA && (data.endDate && data.startDate) && data.startDate > data.endDate) {
                isValid = false;
                errors.endDateError = "* End date must be greater than or equal to start date";
            }
        }
        setData((prevData) => (Object.assign({}, prevData, errors)));
        return isValid;
    };
    const handleCancelButton = () => {
        setIsMagmaDataFetched(false);
        setData(initialState);
        setIsUrlConfirmed(false);
        // const event = new CustomEvent('setupDevicePulseClicked');
        // window.dispatchEvent(event);
    };
    const fetchDpSensorCodes = () => tslib_1.__awaiter(this, void 0, void 0, function* () {
        try {
            const magmaResponse = yield api_1.getSensorCodes(environment_1.environment.host, js_cookie_1.default.get('ACCESS_TOKEN'), js_cookie_1.default.get('USER_ID'), false);
            const magmaCodes = magmaResponse.data.content;
            setSensorCodes([...magmaCodes]);
            console.log("Dp sensor codes fetched successfully");
            return magmaCodes;
        }
        catch (error) {
            console.error("Error fetching sensor codes:", error);
        }
    });
    const fetchInputSensorCodes = () => tslib_1.__awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield api_1.getSensorCodes(data.baseURL, data.accessToken, data.userId, true);
            const codes = response.data.content;
            setInputSensorCodes([...codes]);
            console.log("Sensor codes fetched successfully");
            return codes;
        }
        catch (error) {
            setIsUrlConfirmed(false);
            handleSensorCodeError("Error fetching sensor codes.");
            console.error("Error fetching sensor codes:", error);
        }
    });
    const handlePopUpCancelButton = () => {
        setShowConfirmation(false);
        if (missingColumns.length > 0) {
            return;
        }
        setShowSensorNamingPopup(false);
    };
    const saveSensorCodes = () => tslib_1.__awaiter(this, void 0, void 0, function* () {
        const errors = {};
        let isValid = true;
        if (type === 'csv') {
            missingColumns.forEach((column, index) => {
                const value = (editedSensorCodes[index] && editedSensorCodes[index].codeValue) || '';
                if (!value.trim()) {
                    errors[index] = 'This field is required';
                    isValid = false;
                }
            });
            editedSensorCodes.forEach((sensor, index) => {
                if (sensor.codeValue) {
                    const isDuplicate = sensorCodes.some(existingCode => existingCode.code === sensor.codeValue);
                    if (isDuplicate) {
                        errors[index] = 'This sensor code already exists';
                        isValid = false;
                    }
                }
            });
        }
        setInputErrors(Object.assign({}, errors));
        if (!isValid)
            return;
        if (type === "magma" && !showConfirmation) {
            setShowConfirmation(true);
            return;
        }
        let sensorCodesToSave = [...editedSensorCodes];
        if (type === 'csv') {
            sensorCodesToSave = editedSensorCodes.map(({ code, codeValue }) => ({
                code: codeValue,
                codeValue: code
            }));
        }
        try {
            const response = yield api_1.updateSensorCodes(sensorCodesToSave);
            if (response.status === 200 || response.status === 201) {
                setShowSensorNamingPopup(false);
                setShowSubmit(true);
                handleNextClick();
            }
            else {
                handleSensorCodeError("Error saving sensor codes.");
                console.error("Failed to save sensor codes");
            }
        }
        catch (error) {
            handleSensorCodeError("Error saving sensor codes.");
            console.error("Error saving sensor codes:", error);
        }
    });
    const formatSensorData = (dataArray) => {
        if (data.problemType !== "rca_ms") {
            const sensorName = getSensor_1.mapSensorCodeToName(dataArray[0].code, inputSensorCodes);
            return dataArray.map(data => ({
                Date: data.time,
                [sensorName]: parseFloat(data.value),
                label: data.label || "",
            }));
        }
        else {
            return dataArray;
        }
    };
    const increaseStep = () => tslib_1.__awaiter(this, void 0, void 0, function* () {
        if (!validateFields(ButtonType.ALL)) {
            return;
        }
        if (currentStep < subStepperData.length - 1) {
            const newSubStepper = [...subStepperData];
            newSubStepper[currentStep + 1].active = true;
            setSubStepperData(newSubStepper);
            setCurrentStep(currentStep + 1);
            yield fetchDpSensorCodes();
        }
        else {
            handleNextClick();
        }
    });
    const decreaseStep = () => {
        if (currentStep > 0) {
            const newSubStepper = [...subStepperData];
            newSubStepper[currentStep].active = false;
            setSubStepperData(newSubStepper);
            setCurrentStep(currentStep - 1);
            setIsUrlConfirmed(false);
        }
    };
    const readData = (e) => tslib_1.__awaiter(this, void 0, void 0, function* () {
        const { name, value } = e.target;
        switch (name) {
            case "project name":
                setData((prevData) => (Object.assign({}, prevData, { projectName: value.trim(), projectNameError: "" })));
                break;
            case "project version":
                setData((prevData) => (Object.assign({}, prevData, { projectVersion: value, projectVersionError: "" })));
                break;
            case "problem type":
                setData((prevData) => (Object.assign({}, prevData, { problemType: value, problemTypeError: "" })));
                break;
            case "csv":
                if (value.name.slice(-3) === "csv") {
                    const reader = new FileReader();
                    reader.onload = (event) => {
                        const csv = event.target.result;
                        const json = Utils_1.csvToJson(csv);
                        setData((prevData) => (Object.assign({}, prevData, { csv: json, csvError: "", csvFileName: value.name.split('.csv')[0] + ".csv" })));
                    };
                    reader.readAsText(value);
                }
                else {
                    handleFileTypeError();
                    setData((prevData) => (Object.assign({}, prevData)));
                }
                break;
            case "base_url":
                setData((prevData) => (Object.assign({}, prevData, { baseURL: value, baseURLError: "" })));
                break;
            case "access_token":
                setData((prevData) => (Object.assign({}, prevData, { accessToken: value, accessTokenError: "" })));
                break;
            case "user_id":
                setData((prevData) => (Object.assign({}, prevData, { userId: value, userIdError: "" })));
                break;
            case "batch":
                setData((prevData) => (Object.assign({}, prevData, { batch: value.toString(), batchError: "", device: "", sensor: "" })));
                setDevicesList([]);
                setLoading(true);
                const devicesRes = yield api_1.getDevicesOfBatchNumber(value, data.baseURL, data.accessToken);
                setDevicesList(devicesRes.content);
                setLoading(false);
                break;
            case "device":
                setData((prevData) => (Object.assign({}, prevData, { device: value, deviceError: "" })));
                break;
            case "start date":
                setData((prevData) => (Object.assign({}, prevData, { startDate: value, startDateError: "" })));
                break;
            case "end date":
                setData((prevData) => (Object.assign({}, prevData, { endDate: value, endDateError: "" })));
                break;
            case "sensor":
                setData((prevData) => (Object.assign({}, prevData, { sensor: value, sensorError: "" })));
                break;
            default:
                break;
        }
    });
    const selectType = (val) => {
        setType(val);
        if (val === "magma") {
            setData((prevData) => (Object.assign({}, initialState, { projectName: prevData.projectName, projectVersion: prevData.projectVersion, projectVersionError: "", problemType: prevData.problemType, problemTypeError: "" })));
            setData((prevData) => (Object.assign({}, initialState, { projectName: prevData.projectName, projectVersion: prevData.projectVersion, problemType: prevData.problemType })));
            setIsMagmaDataFetched(false);
            setIsUrlConfirmed(false);
        }
    };
    const addColumnData = (data) => {
        const columnData = {
            selectedCategoricalColumns: data.categorical,
            selectedNumericalColumns: data.numerical,
            selectedTargetColumn: data.target,
            selectedDateTime: data.datetimecolumns,
            remainingColumns: data.remainingcolumns,
            selectedIndexColumns: data.index,
            selectedDropColumns: data.dropcolumns,
            warning: data.warning,
        };
        dispatch(actions_1.saveColumnSelectionS22(columnData));
    };
    const getBatches = () => tslib_1.__awaiter(this, void 0, void 0, function* () {
        setLoading(true);
        console.log("get batches", data);
        try {
            let errors = {};
            const result = yield api_1.getAllBatches(data.baseURL, data.accessToken);
            console.log(result);
            if (result.message === "Success") {
                setBatchList(result.content);
                setIsUrlConfirmed(true);
            }
            else {
                if (result.message.includes("401")) {
                    errors.accessTokenError = "* Access token is wrong";
                    handleSensorCodeError("Invalid Access token");
                }
                else if (result.message.includes("Network Error")) {
                    errors.baseURLError = "* Check the Base URL or Network";
                    handleSensorCodeError("Check the Base URL or Network");
                }
                setData((prevData) => (Object.assign({}, prevData, errors)));
                setIsUrlConfirmed(false);
            }
        }
        catch (error) {
            console.error("Error fetching batches:", error);
            setIsUrlConfirmed(false);
        }
        finally {
            setLoading(false);
        }
    });
    const addSnackbar = (message, type) => {
        const id = Date.now();
        setSnackbars(prev => [...prev, { id, message, type }]);
        setTimeout(() => {
            removeSnackbar(id);
        }, 5000);
    };
    const removeSnackbar = (id) => {
        setSnackbars(prev => prev.filter(snack => snack.id !== id));
    };
    const handleAddMore = () => tslib_1.__awaiter(this, void 0, void 0, function* () {
        setIsMagmaDataFetched(false);
        setShowConfirmation(false);
        setShowSensorNamingPopup(false);
        if (!isMultipleDataset) {
            setData((prevData) => {
                const updatedStackedCSV = prevData.stackedCSV || {};
                if (!updatedStackedCSV[data.device]) {
                    updatedStackedCSV[data.device] = [];
                }
                updatedStackedCSV[data.device].push(...data.csv);
                return Object.assign({}, prevData, { stackedCSV: updatedStackedCSV });
            });
        }
        console.log("add more");
        setIsMultipleDataset(true);
    });
    const handleFetchData = () => tslib_1.__awaiter(this, void 0, void 0, function* () {
        if (!validateFields(ButtonType.FETCH_DATA)) {
            return;
        }
        setLoading(true);
        try {
            let sensorRes;
            if (data.problemType !== "rca_ms") {
                sensorRes = yield api_1.getSensorData(data.device, data.sensor, data.startDate, data.endDate, data.baseURL, data.accessToken);
            }
            else {
                const sensorList = getSensor_1.getSensorNamesToCode(selectedSensors, inputSensorCodes);
                sensorRes = yield api_1.getSensorData_rca_ms(data.device, sensorList, data.startDate, data.endDate, data.baseURL, data.accessToken, data.userId);
            }
            if (sensorRes.message === "Success") {
                if (data.problemType !== "rca_ms") {
                    setDeviceDataSensorCodes([sensorRes.content[0].code]);
                }
                else {
                    const codes = sensorRes.content.map(item => {
                        if (item.data && item.data.length > 0 && item.data[0].length > 0) {
                            return item.data[0][0].code;
                        }
                        return null;
                    }).filter(code => code !== null);
                    setDeviceDataSensorCodes(codes);
                }
                setIsMagmaDataFetched(true);
                const sensorData = formatSensorData(sensorRes.content);
                console.log("sensorData", sensorData);
                if (data.problemType !== "rca_ms") {
                    setData((prevData) => (Object.assign({}, prevData, { csv: sensorData, csvError: "" })));
                }
                else {
                    console.log("sensorData else", sensorData);
                    const data_rca_ms = [];
                    data_rca_ms.push({
                        "deviceId": data.device,
                        "data": flattenDataArrays(sensorData)
                    });
                    setData((prevData) => (Object.assign({}, prevData, { csv: data_rca_ms, csvError: "" })));
                }
                if (isMultipleDataset) {
                    setData((prevData) => {
                        const updatedStackedCSV = Object.assign({}, prevData.stackedCSV) || {};
                        if (data.problemType !== "rca_ms") {
                            if (!updatedStackedCSV[data.device]) {
                                updatedStackedCSV[data.device] = [];
                            }
                            updatedStackedCSV[data.device].push(...sensorData);
                        }
                        else {
                            updatedStackedCSV[data.device] = updatedStackedCSV[data.device] || [];
                            updatedStackedCSV[data.device].push({
                                "deviceId": data.device,
                                "data": flattenDataArrays(sensorData)
                            });
                        }
                        return Object.assign({}, prevData, { stackedCSV: updatedStackedCSV });
                    });
                }
            }
            else {
                console.error("Error fetching sensor data:", sensorRes.message);
            }
        }
        catch (error) {
            console.error("There was an error initiating the project!", error);
        }
        finally {
            setLoading(false);
        }
    });
    const handleConformURL = () => tslib_1.__awaiter(this, void 0, void 0, function* () {
        if (!validateFields(ButtonType.CONFORM_URL)) {
            return;
        }
        yield getBatches();
        yield fetchInputSensorCodes();
    });
    const handleNextClick = () => tslib_1.__awaiter(this, void 0, void 0, function* () {
        if (showSubmit) {
            dispatch(actions_1.changeMainStep(mainStep + 1));
            localStorage.setItem('pageFlag', 2);
            return;
        }
        if (showSensorNamingPopup)
            return;
        if (!validateFields(ButtonType.ALL)) {
            return;
        }
        setLoading(true);
        try {
            const projectData = {
                projectname: data.projectName,
                problemtype: data.problemType,
                version_name: "Version-" + data.projectVersion,
                userid: js_cookie_1.default.get('USER_ID'),
                filetype: type === "magma" ? "magma_multiple_device" : "upload_csv"
            };
            dispatch(actions_1.saveProjectInfo(projectData));
            projectData.data_path = data.csv;
            if (isMultipleDataset) {
                projectData.data_path = data.stackedCSV;
            }
            if (type === "magma" && !isMultipleDataset) {
                console.log("data before set #########", data.csv);
                projectData.data_path = {
                    [data.device]: data.csv
                };
            }
            if (projectData.problemtype === "rca_ms") {
                projectData.data = data.csv;
                delete projectData.data_path;
            }
            const initRes = yield api_1.initiateProject(projectData);
            addColumnData(initRes.data);
            if (type === "csv") {
                const allColumns = [
                    ...(initRes.data.categorical || []),
                    ...(initRes.data.numerical || []),
                    ...(initRes.data.target || []),
                    ...(initRes.data.datetimecolumns || []),
                    ...(initRes.data.remainingcolumns || [])
                ];
                const sensorCodeValues = sensorCodes.map(code => code.codeValue);
                let missing = allColumns.filter(column => !sensorCodeValues.includes(column));
                const datetimeColumns = Utils_2.detectDateTimeColumns(data.csv);
                missing = missing.filter(column => !datetimeColumns.includes(column));
                if (missing.length > 0) {
                    setEditedSensorCodes(missing.map(column => ({ code: column, codeValue: '' })));
                    setMissingColumns(missing);
                    setShowSensorNamingPopup(true);
                    return;
                }
            }
            else if (type === "magma") {
                setShowConfirmation(false);
                const fetchedSensorCodes = deviceDataSensorCodes;
                console.log("Fetched deviceDataSensorCodes:", fetchedSensorCodes);
                const definedSensorCodes = sensorCodes.map(code => code.code);
                console.log("Existing sensorCodes:", definedSensorCodes);
                const missing = [];
                fetchedSensorCodes.forEach(code => {
                    if (!definedSensorCodes.includes(code)) {
                        const inputMatch = inputSensorCodes.find(input => input.code === code);
                        if (inputMatch) {
                            missing.push({
                                code: inputMatch.code,
                                codeValue: inputMatch.codeValue
                            });
                        }
                    }
                });
                if (!showConfirmation) {
                    setEditedSensorCodes(missing);
                    setMissingColumns(missing);
                    setShowConfirmation(true);
                    setShowSensorNamingPopup(true);
                    return;
                }
            }
            dispatch(actions_1.changeMainStep(mainStep + 1));
            localStorage.setItem('pageFlag', 2);
        }
        catch (error) {
            handleSensorCodeError("Error initiating the project.");
            console.error("There was an error initiating the project!", error);
        }
        finally {
            setLoading(false);
        }
    });
    function flattenDataArrays(input) {
        console.log("input start", input);
        input.forEach(item => {
            if (Array.isArray(item.data) && item.data.length === 1 && Array.isArray(item.data[0])) {
                item.data = item.data[0];
            }
        });
        console.log("input end", input);
        return input;
    }
    const menuItemStyle = {
        fontSize: "14px",
    };
    return (react_1.default.createElement(core_1.Grid, { container: true },
        loading && (react_1.default.createElement("div", { className: styleLocal.loadingOverlay },
            react_1.default.createElement(react_spinners_1.PropagateLoader, { color: "#3f51b5" }))),
        react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 12, md: 12, lg: 12, style: {
                textAlign: "center",
                paddingTop: "20px",
                paddingBottom: "20px",
            } },
            react_1.default.createElement(sub_layout_1.SubLayout, { data: subStepperData, setCurrentStepByClick: setCurrentStepByClick, currentStep: currentStep })),
        react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 12, md: 1, lg: 1 }),
        currentStep === 0 && (react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 12, md: 10, lg: 10 },
            react_1.default.createElement(project_initiation_step1_1.ProjectInitiationStep1, { data: data, readData: readData, errorMessages: {
                    projectNameError: data.projectNameError,
                    projectVersionError: data.projectVersionError,
                    problemTypeError: data.problemTypeError
                } }))),
        currentStep === 1 && (react_1.default.createElement(project_initiation_step2_1.ProjectInitiationStep2, { type: type, data: data, readData: readData, errorMessages: {
                csvError: data.csvError,
                baseURLError: data.baseURLError,
                accessTokenError: data.accessTokenError,
                userIdError: data.userIdError,
                batchError: data.batchError,
                deviceError: data.deviceError,
                sensorError: data.sensorError,
                startDateError: data.startDateError,
                endDateError: data.endDateError
            }, selectType: selectType, handleConformURL: handleConformURL, handleFetchData: handleFetchData, handleAddMore: handleAddMore, batchList: batchList, devicesList: devicesList, sensors: sensors, selectedSensors: selectedSensors, setSelectedSensors: setSelectedSensors, isMagmaDataFetched: isMagmaDataFetched, selectedSensorValue: selectedSensorValue, inputSensorCodes: inputSensorCodes, isUrlConfirmed: isUrlConfirmed })),
        react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 12, md: 7, lg: 7 }),
        react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 12, md: 4, lg: 4 },
            react_1.default.createElement("div", { style: { width: "100%", textAlign: "right" } },
                react_1.default.createElement(core_1.Button, { variant: "outlined", style: themes_1.cancelBotton, onClick: currentStep === 0 ? handleCancelButton : decreaseStep }, currentStep === 0 ? "Cancel" : "Previous"),
                react_1.default.createElement(core_1.Button, { style: Object.assign({}, themes_1.nextBotton, { backgroundColor: currentStep === 1 && type === "magma" && Object.keys(data.csv).length === 0 ? "gray" : themes_1.nextBotton.backgroundColor }), sx: {
                        "&:hover": {
                            backgroundColor: "#01446F",
                        },
                    }, disabled: (currentStep === 0 && !permission_1.hasUserPermission("MODEL_BUILDER", "CREATE")) || (currentStep === 1 && type === "magma" && Object.keys(data.csv).length === 0), onClick: increaseStep }, "Next"))),
        react_1.default.createElement("div", { style: {
                position: 'fixed',
                bottom: 20,
                right: 20,
                zIndex: 1400,
                display: 'flex',
                flexDirection: 'column-reverse',
                alignItems: 'flex-end',
                gap: '10px'
            } }, snackbars.map((snack) => (react_1.default.createElement("div", { key: snack.id, style: {
                width: '100%'
            } },
            react_1.default.createElement(lab_1.Alert, { severity: snack.type, variant: "filled", sx: {
                    width: 'auto',
                    maxWidth: '400px',
                    justifyContent: 'flex-end'
                }, onClose: () => removeSnackbar(snack.id) }, snack.message))))),
        showSensorNamingPopup && (react_1.default.createElement("div", { className: styleLocal.sensorNamingPopup },
            react_1.default.createElement("div", { className: styleLocal.popupContent }, (!showConfirmation ? (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(core_1.Typography, { variant: "h6", className: styleLocal.popupHeader }, "SENSOR CODE LABELING"),
                react_1.default.createElement("div", { style: {
                        maxHeight: '50vh',
                        overflowY: 'auto',
                        padding: '24px',
                    } },
                    react_1.default.createElement("div", { style: {
                            display: 'flex',
                            gap: '95px',
                            marginBottom: '8px',
                        } },
                        react_1.default.createElement(core_1.Typography, { className: styleLocal.textFieldFont }, "Sensor Name"),
                        react_1.default.createElement(core_1.Typography, { className: styleLocal.textFieldFont }, "Sensor Code")),
                    missingColumns.map((column, index) => (react_1.default.createElement("div", { key: index, style: {
                            marginBottom: '16px',
                            display: "flex",
                            gap: "16px",
                            alignItems: 'center'
                        } },
                        react_1.default.createElement(core_2.Tooltip, { title: column, arrow: true, PopperProps: { style: { zIndex: 11500 } } },
                            react_1.default.createElement("span", { style: { width: '160px' } },
                                react_1.default.createElement(core_1.Typography, { variant: "subtitle1", className: styleLocal.sensorLabel, style: {
                                        display: 'block',
                                        marginBottom: inputErrors[index] ? '24px' : '0px'
                                    } }, column))),
                        react_1.default.createElement("div", { style: { flexGrow: 1 } },
                            react_1.default.createElement(core_1.TextField, { fullWidth: true, variant: "outlined", size: "small", style: {
                                    flexGrow: 1
                                }, InputProps: {
                                    style: {
                                        height: '40px'
                                    }
                                }, value: (editedSensorCodes[index] && editedSensorCodes[index].codeValue !== undefined)
                                    ? editedSensorCodes[index].codeValue
                                    : column, onChange: (e) => {
                                    const newCodes = [...editedSensorCodes];
                                    if (!newCodes[index]) {
                                        newCodes[index] = { code: column, codeValue: e.target.value };
                                    }
                                    else {
                                        newCodes[index].codeValue = e.target.value;
                                    }
                                    setEditedSensorCodes(newCodes);
                                    setInputErrors((prev) => (Object.assign({}, prev, { [index]: '' })));
                                }, error: !!inputErrors[index] }),
                            inputErrors[index] && (react_1.default.createElement(core_1.Typography, { variant: "body2", color: "error", style: { marginTop: '4px', marginLeft: '4px' } }, inputErrors[index]))))))),
                react_1.default.createElement("div", { className: styleLocal.popupFooter },
                    react_1.default.createElement(core_1.Button, { variant: "outlined", style: Object.assign({}, themes_1.cancelBotton, { width: '120px', height: '40px' }), onClick: () => setShowSensorNamingPopup(false) }, "Cancel"),
                    react_1.default.createElement(core_1.Button, { variant: "contained", color: "primary", onClick: saveSensorCodes, style: Object.assign({}, themes_1.nextBotton, { width: '120px', height: '40px', minWidth: '0px' }) }, "Submit")))) : (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(core_1.Typography, { variant: "h6", style: {
                        fontSize: '18px',
                        fontWeight: 600,
                        color: '#324054',
                        boxShadow: '0px 4px 40px 0px #00000014',
                        padding: '16px 32px',
                    } }, "Confirmation"),
                react_1.default.createElement(core_1.Typography, { variant: "body1", style: {
                        marginBottom: '24px',
                        fontSize: '14px',
                        color: '#324054',
                        padding: '24px 24px 0px 32px',
                    } }, "Are you sure you want to submit these sensor labels?"),
                react_1.default.createElement("div", { style: {
                        display: 'flex',
                        justifyContent: 'flex-end',
                        marginTop: '24px',
                        gap: '12px',
                        padding: '0px 24px',
                    } },
                    react_1.default.createElement(core_1.Button, { variant: "outlined", style: Object.assign({}, themes_1.addAnother, { width: '100%', height: '40px', marginRight: 'auto' }), onClick: handleAddMore, hidden: !isMagmaDataFetched }, "+ Add Another Data"),
                    react_1.default.createElement(core_1.Button, { variant: "outlined", style: Object.assign({}, themes_1.cancelBotton, { width: '50%', height: '40px' }), onClick: handlePopUpCancelButton }, "Cancel"),
                    react_1.default.createElement(core_1.Button, { variant: "contained", color: "primary", onClick: saveSensorCodes, style: Object.assign({}, themes_1.nextBotton, { width: '50%', height: '40px', minWidth: '0' }) }, "Confirm"))))))))));
}
exports.ProjectInitiation = ProjectInitiation;
//# sourceMappingURL=project-initiation.js.map